module.exports = __webpack_public_path__ + "img/ballogo.c68f4f69.svg";